import React, { useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import Image from '../AppImage';

const signOut = async () => {
  // Implement sign out logic here
  // This is a placeholder implementation
  return Promise.resolve();
};

const RoleAdaptiveNavbar = ({ userRole = 'visitor', userName = 'User' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const galleryId = searchParams?.get('id');

  const getNavigationItems = () => {
    const baseItems = [];

    if (userRole === 'owner') {
      baseItems?.push(
        { label: 'Dashboard', path: '/owner-dashboard', icon: 'LayoutDashboard' },
        { label: 'Galleries', path: '/gallery-management', icon: 'Images' },
        { label: 'Create Gallery', path: '/gallery-creation', icon: 'Plus' }
      );
    } else if (userRole === 'contributor') {
      baseItems?.push(
        { label: 'Dashboard', path: '/contributor-dashboard', icon: 'LayoutDashboard' },
        { label: 'My Galleries', path: '/gallery-management', icon: 'Images' },
        { label: 'Create Gallery', path: '/gallery-creation', icon: 'Plus' }
      );
    } else if (userRole === 'visitor') {
      baseItems?.push(
        { label: 'Galleries', path: '/gallery-viewer', icon: 'Images' }
      );
    }

    return baseItems;
  };

  const navigationItems = getNavigationItems();

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      
      // Navigate based on role
      if (userRole === 'visitor') {
        navigate('/user-registration');
      } else {
        navigate('/admin-login');
      }
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <nav className="navbar-container">
        <div className="navbar-content">
          <div 
            className="navbar-logo"
            onClick={() => handleNavigation(userRole === 'owner' ? '/owner-dashboard' : userRole === 'contributor' ? '/contributor-dashboard' : '/gallery-viewer')}
          >
            <Image 
              src="/assets/images/RVS_InitialLogo_01-02-1768324259986.png" 
              alt="RVS Logo" 
              className="h-8 w-auto object-contain"
            />
          </div>

          <div className="navbar-menu">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`navbar-menu-item ${isActivePath(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </button>
            ))}
            
            <Button
              variant="ghost"
              size="sm"
              iconName="LogOut"
              iconPosition="left"
              onClick={handleSignOut}
              className="ml-2"
            >
              Logout
            </Button>
          </div>

          <button
            className="navbar-mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </nav>
      {isMobileMenuOpen && (
        <div className="navbar-mobile-menu">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`navbar-mobile-menu-item ${isActivePath(item?.path) ? 'active' : ''}`}
            >
              <div className="flex items-center gap-3">
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </div>
            </button>
          ))}
          
          <button
            onClick={handleSignOut}
            className="navbar-mobile-menu-item"
          >
            <div className="flex items-center gap-3">
              <Icon name="LogOut" size={20} />
              <span>Logout</span>
            </div>
          </button>
        </div>
      )}
    </>
  );
};

export default RoleAdaptiveNavbar;